<template>
  <div class="row">
    <div class="card" style="margin:  100px 0">
      <div class="card-content">
        <!-- create & update user form -->
        <form @submit.prevent="submit">
          <!-- full name field  for all users  -->
          <div class="row">
            <div class="input-field col s12">
              <i class="material-icons prefix" :class="user.fullName ? 'active' : ''">person</i>
              <input id="fullName" type="text" v-model="user.fullName" required class="validate" />
              <label for="fullName" :class="user.fullName ? 'active' : ''">Full Name</label>
            </div>
          </div>

          <!-- email field for student and teadchers-->
          <div class="row">
            <div class="input-field col s12">
              <i class="material-icons prefix" :class="user.email ? 'active' : ''">email</i>
              <input id="email" type="email" v-model="user.email" required class="validate" />
              <label for="email" :class="user.email ? 'active' : ''">Email</label>
            </div>
          </div>

          <!-- phone for students -->
          <div v-if="user.role === 'student'" class="row">
            <div class="input-field col s12">
              <i class="material-icons prefix" :class="user.phone ? 'active' : ''">phone</i>
              <input id="phone" type="tel" v-model="user.phone" required class="validate" />
              <label for="phone" :class="user.phone ? 'active' : ''">Phone</label>
            </div>
          </div>

          <!-- password for all users -->
          <div v-if="this.$route.name !== 'updateUser'" class="row">
            <div class="input-field col s12">
              <i
                @click="password = !password"
                class="material-icons prefix"
              >{{ password ? 'visibility' : 'visibility_off' }}</i>
              <input
                id="password"
                :type="password ? 'text' : 'password'"
                v-model="user.password"
                required
                class="validate"
              />
              <label for="password">Password</label>
            </div>
          </div>

          <!-- select level for students -->
          <div v-if="user.role === 'student'" class="row">
            <div class="input-field col s12">
              <select v-model="user.level" required class="browser-default">
                <option value disabled selected>Select Level</option>
                <option
                  v-for="level in $store.getters.getInfo"
                  :key="level.level"
                  :value="level.level"
                >Level {{ level.level }}</option>
              </select>
            </div>
          </div>

          <br />

          <!-- select user role -->
          <h6 v-if="this.$route.name !== 'updateUser'" class="center">select user role</h6>
          <br v-if="this.$route.name !== 'updateUser'" />
          <p v-if="this.$route.name !== 'updateUser'" class="center">
            <label>
              <input
                type="radio"
                value="student"
                v-model="user.role"
                @click="$router.push({name:'createUser', params: { role: 'student' }})"
              />
              <span>Student</span>
            </label>

            <label>
              <input
                type="radio"
                value="admin"
                v-model="user.role"
                @click="$router.push({name:'createUser', params: { role: 'admin' }})"
              />
              <span>Admin</span>
            </label>
          </p>

          <br v-if="this.$route.name !== 'updateUser'" />
          <br v-if="this.$route.name !== 'updateUser'" />
          <br v-if="this.$route.name !== 'updateUser'" />

          <!-- submit button -->
          <div class="row center">
            <button class="btn indigo">{{ $route.name === 'createUser' ? 'Create' : 'Update'}}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      user: {
        user: "",
        fullName: "",
        email: "",
        phone: "",
        level: "",
        role: ""
      },
      password: false
    };
  },
  created() {
    this.user.role = this.$route.params.role;

    if (
      this.$route.name === "createUser" &&
      !["student", "admin"].includes(this.$route.params.role)
    )
      this.$router.push({ name: "notFound" });

    if (this.$route.name === "updateUser") {
      this.$store
        .dispatch("getUser", this.$route.params.user)
        .then(response => {
          this.user.user = this.$route.params.user;
          this.user.fullName = response.data.fullName;
          this.user.email = response.data.email;
          this.user.phone = response.data.phone;
          this.user.role = response.data.role;
          this.user.level = response.data.level;
        });
    }
  },
  methods: {
    submit() {
      if (this.$route.name === "updateUser")
        this.$store.dispatch("updateUser", this.user);
      else if (this.user.role === "student")
        this.$store.dispatch("createUser", this.user);
      else
        this.$store.dispatch("createUser", {
          fullName: this.user.fullName,
          email: this.user.email,
          role: this.user.role,
          password: this.user.password
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/UserOperations.vue